import { hasPermission } from "@/router/protected-routes"
import { useAdversaries } from "@/stores/adversaries"
import type { RouteRecordRaw } from "vue-router"

function getAdversaryName() {
  const adversariesStore = useAdversaries()
  return adversariesStore.currentAdversary.name || ""
}

const adversariesRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "adversariesList",
    component: () => import("@/templates/adversaries/AdversariesList.vue")
  },
  {
    path: "view/:adversaryId(\\d+)",
    name: "adversaryView",
    component: () => import("@/templates/adversaries/AdversaryView.vue"),
    meta: { breadcrumb: getAdversaryName }
  },
  {
    path: "create",
    name: "adversaryCreate",
    component: () => import("@/templates/adversaries/AdversaryCreate.vue"),
    meta: { breadcrumb: "adversaries.createTitle" },
    beforeEnter: () => {
      return hasPermission("/api/v1/adversary", "post")
    }
  },
  {
    path: "edit/:adversaryId(\\d+)",
    name: "adversaryEdit",
    component: () => import("@/templates/adversaries/AdversaryCreate.vue"),
    meta: { breadcrumb: getAdversaryName },
    beforeEnter: () => {
      return hasPermission("/api/v1/adversary/{adversary_id}", "put")
    }
  }
]

export default adversariesRoutes
